import { render, staticRenderFns } from "./AdicionarComissaoDialog.vue?vue&type=template&id=65483a9f&"
import script from "./AdicionarComissaoDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarComissaoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports